import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Prescriber } from "@modules/prescribers/types";
import { PrescriberFormValues } from "@modules/prescribers/validations";

import { editPrescriberService } from "./service";
import { UseEditPrescriberMutationOptions } from "./types";

export function useEditPrescriberMutation(
  options?: UseEditPrescriberMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<Prescriber, ApiError, { id: string; data: PrescriberFormValues }>({
    mutationFn: ({ id, data }) => editPrescriberService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("prescriber_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
